declare var $: any;
export class GridConfig {
    id: string;
    data: any[];
    colModel: any[];
    multiSelect: boolean;
    width: any;
    height: any;
    container: string;
    
    constructor(
        id: string,
        data: any[],
        colModel: any[],
        container: string,
        multiSelect: boolean = true,
        width: any = $("." + container).width(),
        height: any = $("." + container).height()
    ) {
        this.id = id;
        this.data = data;
        this.colModel = colModel;
        this.container = container;
        this.multiSelect = multiSelect;
        this.width = width;
        if (width != "100%")
            this.width = width - 2;
        this.height = height;
        if (height != "100%")
            this.height = height - 30;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./App/Classes/GridConfig.ts